module.exports = __webpack_public_path__ + "img/download_txt1.65adb187.png";